<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%">
    <v-card>
      <v-toolbar flat dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-md-and-up" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Kunde bearbeiten</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text :disabled="!customer.valid" v-show="$vuetify.breakpoint.sm" @click.native="updateCustomer">
            Kunde bearbeiten
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn icon :disabled="!customer.valid" v-show="$vuetify.breakpoint.xs" @click.native="createCustomer">
            <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="customer.valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-subheader class="title">Persönliche Daten</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="E-Mail"
                  v-model="customer.email"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-select
                  label="Anrede"
                  :items="salutations"
                  v-model="customer.salutation">
                </v-select>
              </v-flex>
              <v-flex xs9></v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="customer.firstName"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname/Firmenname"
                  v-model="customer.lastName"
                  :rules="mandatoryFieldRule"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Zusatz"
                  v-model="customer.addition"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Straße"
                  v-model="customer.street"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Postleitzahl"
                  v-model="customer.zipCode"
                ></v-text-field>
              </v-flex>
              <v-flex xs9>
                <v-text-field
                  label="Stadt"
                  v-model="customer.city"
                  :rules="mandatoryFieldRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Telefon-Nummer"
                  mask="###########################"
                  v-model="customer.phoneNumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs9></v-flex>
              <v-flex xs3>
                <v-switch
                  v-model="customer.business"
                  label="Gewerblicher Kunde"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs9>
                <v-switch
                  v-model="customer.calculateVat"
                  label="Mehrwertsteuer berechnen"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Anfahrtsberechnung</v-subheader>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-switch
                  v-model="customer.approachCharge"
                  label="Anfahrt berechnen"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-currency-field
                  :disabled="!customer.approachCharge"
                  label="Betrag pro Anfahrten"
                  v-model="customer.approachChargeValue"
                  v-bind="currencyConfig"
                >
                </v-currency-field>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-switch
                  :disabled="!customer.approachCharge"
                  v-model="customer.fixDrives"
                  label="Feste Anzahl an Fahrten"
                  color="primary"
                ></v-switch>
              </v-flex>
              <v-flex xs6 sm6 md3>
                <v-text-field
                  :disabled="!(customer.fixDrives && customer.approachCharge)"
                  label="Anzahl Anfahrten"
                  v-model="customer.fixDrivesNumber"
                  type="number"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Anmerkungen zum Kunden</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  solo
                  name="instruction-input"
                  auto-grow
                  v-model="customer.internalInfos"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Mitarbeiterhinweis</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  solo
                  name="instruction-input"
                  auto-grow
                  v-model="customer.infos"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Mitarbeiter mit Anfahrtspauschale</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="users"
                  v-model="customer.fareUsers"
                  chips
                  deletable-chips
                  :item-value="userValue"
                  :item-text="userText"
                  return-object
                  label="Mitarbeiter eingeben"
                  multiple
                  @input.native="loadUsers"
                >
                  <template
                    slot="selection"
                    slot-scope="data"
                  >
                    <v-chip
                      :input-value="data.selected"
                      close
                      class="chip--select-multi"
                      @input="removeUser(data.item)"
                    >
                      {{ data.item.firstName }} {{ data.item.lastName }} - {{ data.item.street }}, {{ data.item.city }}
                    </v-chip>
                  </template>
                  <template></template>
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="title">Dienstleistungszuweisung</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="customerServiceDefinitions"
                  v-model="customer.customerServiceDefinitions"
                  chips
                  deletable-chips
                  :item-value="serviceValue"
                  :item-text="serviceText"
                  return-object
                  required
                  label="Dienstleistung suchen"
                  multiple
                >
                </v-select>
                <v-data-table
                  :headers="headers"
                  :items="customer.customerServiceDefinitions"
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-dialog v-model="dialog" max-width="900px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Dienstleistung bearbeiten</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.description" label="Beschreibung"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.extraLine1" label="Extrazeile 1"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.extraLine2" label="Extrazeile 2"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.extraLine3" label="Extrazeile 3"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select :items="frequencies" v-model="editedItem.frequency" label="Abrechnungsrhythmus"></v-select>
                          </v-flex>
                          <v-flex xs3>
                            <v-switch v-model="editedItem.flatRate" label="Pauschale?" color="primary"></v-switch>
                          </v-flex>
                          <v-flex xs9>
                            <v-text-field v-model="editedItem.flatRateFee" label="Pauschalbetrag"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="closeDefinitionDialog">Abbrechen</v-btn>
                      <v-btn color="primary" text @click="saveDefinition">Speichern</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                  </template>
                  <template v-slot:item.frequency="{ item }">
                    {{getFrequencyRowText(item.frequency)}}
                  </template>
                  <template v-slot:item.flatRate="{ item }">
                    <v-icon
                      v-if="item.flatRate"
                      small
                      dark
                      color="primary"
                      class="mr-2"
                    >
                    check_circle
                    </v-icon>
                    <v-icon
                      v-else
                      small
                      dark
                      color="primary"
                      class="mr-2"
                    >
                    cancel
                    </v-icon>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      small
                      color="primary"
                      class="mr-2"
                      @click="edit(item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      color="primary"
                      @click="remove(item)"
                    >
                      delete
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    Keine Auswahl
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">Abbrechen</v-btn>
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="primary"
          text
          @click.native="updateCustomer">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import debounce from 'debounce'

  export default {
    name: 'EditCustomerDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      customer: {
        type: Object,
        default: function () {
          return {
            valid: false,
            email: '',
            salutation: '',
            firstName: '',
            lastName: '',
            business: false,
            addition: '',
            approachCharge: false,
            approachChargeValue: '',
            fixDrives: false,
            fixDrivesNumber: 0,
            customerServiceDefinitions: [],
            fareUsers: [],
            street: '',
            city: '',
            zipCode: '',
            phoneNumber: '',
            infos: '',
            internalInfos: '',
            calculateVat: true
          }
        }
      }
    },
    data () {
      return {
        valid: true,
        page: 0,
        size: 50,
        dialog: false,
        currencyConfig: {
          decimal: ',',
          thousands: '.',
          prefix: '€ ',
          precision: 2
        },
        headers: [
          {
            text: 'Dienstleistung',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Beschreibung',
            align: 'left',
            sortable: false,
            value: 'description'
          },
          {
            text: 'Extrazeile 1',
            align: 'left',
            sortable: false,
            value: 'extraLine1'
          },
          {
            text: 'Extrazeile 2',
            align: 'left',
            sortable: false,
            value: 'extraLine2'
          },
          {
            text: 'Extrazeile 3',
            align: 'left',
            sortable: false,
            value: 'extraLine3'
          },
          {
            text: 'Abrechnungsrhythmus',
            align: 'left',
            sortable: false,
            value: 'frequency'
          },
          {
            text: 'Pauschale?',
            align: 'left',
            sortable: false,
            value: 'flatRate'
          },
          {
            text: 'Pauschalbetrag',
            align: 'left',
            sortable: false,
            value: 'flatRateFee'
          },
          {
            text: 'Aktionen',
            align: 'left',
            sortable: false,
            value: 'action'
          }
        ],
        editedIndex: -1,
        editedItem: {
          service: {
            id: 0,
            name: ''
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        },
        defaultItem: {
          service: {
            id: 0,
            name: ''
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        },
        salutations: [
          {
            value: 'EMPTY',
            text: ''
          },
          {
            value: 'SIR',
            text: 'Herr'
          },
          {
            value: 'MADAM',
            text: 'Frau'
          },
          {
            value: 'FAMILY',
            text: 'Familie'
          },
          {
            value: 'COMPANY',
            text: 'Firma'
          }
        ],
        frequencies: [
          {
            value: 'HOURLY',
            text: 'Stündlich',
            disabled: false
          },
          {
            value: 'DAILY',
            text: 'Täglich',
            disabled: true
          },
          {
            value: 'MONTHLY',
            text: 'Monatlich',
            disabled: true
          }
        ],
        numberRule: [
          n => !!n || !isNaN(n) || 'Dieses Feld muss eine Zahl sein'
        ],
        salutationRule: [
          v => !!v || 'Bitte wählen sie eine Begrüßung aus'
        ],
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        emailRules: [
          v => !!v || 'E-Mail nicht angegeben',
          v => /(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        ]
      }
    },
    computed: {
      loading: function () {
        return this.$store.getters.loading
      },
      users: function () {
        return this.$store.getters.allUsers
      },
      loadUsers: function () {
        return debounce(this.fetchUsers, 500)
      },
      customerServiceDefinitions: function () {
        const allServices = this.$store.getters.services
        return allServices.map(service => ({
          name: service.name,
          service: {
            id: service.id,
            name: service.name
          },
          description: '',
          extraLine1: '',
          extraLine2: '',
          extraLine3: '',
          flatRate: false,
          flatRateFee: '0,00',
          frequency: 'HOURLY'
        }))
      },
      editItemFlatRate: function () {
        return this.editedItem.flatRate
      }
    },
    watch: {
      editItemFlatRate (newFlatRate, oldFlatRate) {
        if (oldFlatRate && !newFlatRate) {
          this.frequencies.forEach(frequency => {
            if (frequency.value === 'HOURLY') {
              frequency.disabled = false
            } else {
              frequency.disabled = true
            }
          })
          this.editedItem.frequency = 'HOURLY'
        } else {
          this.frequencies.forEach(frequency => {
            if (frequency.value === 'HOURLY') {
              frequency.disabled = true
            } else {
              frequency.disabled = false
            }
          })
          if (this.editedItem.frequency === 'HOURLY') {
            this.editedItem.frequency = 'MONTHLY'
          }
        }
      }
    },
    created () {
      this.$store.dispatch('loadServices',
        {
          searchTerms: ''.split(' '),
          page: this.page,
          size: this.size
        })

      this.$store.dispatch('loadUsers',
        {
          searchTerms: ''.split(' '),
          page: this.page,
          size: this.size
        })
    },
    methods: {
      updateCustomer () {
        this.$store.dispatch('editCustomer', {
          id: this.customer.id,
          email: this.customer.email,
          approachCharge: this.customer.approachCharge,
          approachChargeValue: this.customer.approachChargeValue,
          fixDrives: this.customer.approachCharge && this.customer.fixDrives,
          fixDrivesNumber: this.customer.fixDrivesNumber,
          customerServiceDefinitions: this.mapCustomerServiceDefinitions(this.customer.customerServiceDefinitions),
          fareUsers: this.mapFlareUsers(this.customer.fareUsers),
          business: this.customer.business,
          addition: this.customer.addition,
          salutation: this.customer.salutation,
          firstName: this.customer.firstName,
          lastName: this.customer.lastName,
          street: this.customer.street,
          city: this.customer.city,
          zipCode: this.customer.zipCode,
          phoneNumber: this.customer.phoneNumber,
          infos: this.customer.infos,
          internalInfos: this.customer.internalInfos,
          calculateVat: this.customer.calculateVat
        })
          .then(() => this.$store.dispatch('showNotification', {
            title: 'Kunde erfolgreich gespeichert.',
            type: 'primary'
          }))
          .finally(() => this.$emit('close'))
      },
      fetchUsers (event) {
        if (event.target.value.length > 2) {
          this.$store.dispatch('resetUsers')
          this.$store.dispatch('loadUsers', {
            searchTerms: event.target.value.split(' '),
            page: this.page,
            size: this.size
          })
        }
      },
      serviceValue (item) {
        if (Array.isArray(item)) {
          return item
        }
        return item.service.id
      },
      serviceText (item) {
        if (!Array.isArray(item)) {
          return item.service.name
        }
      },
      textRateNameMapping (item) {
        return item.service.name
      },
      mapCustomerServiceDefinitions (definitions) {
        return definitions.map(definition => ({
          id: definition.id,
          service: {
            id: definition.service.id,
            name: definition.service.name
          },
          description: definition.description,
          extraLine1: definition.extraLine1,
          extraLine2: definition.extraLine2,
          extraLine3: definition.extraLine3,
          flatRate: definition.flatRate,
          flatRateFee: this.mapToFloat(definition.flatRateFee),
          frequency: definition.frequency
        }))
      },
      userValue (item) {
        if (Array.isArray(item)) {
          return item
        }
        return item.id
      },
      userText (item) {
        return item.lastName + ', ' + item.firstName
      },
      mapToFloat (nonFloatNumber) {
        if (isNaN(nonFloatNumber)) {
          return parseFloat(nonFloatNumber.replace(',', '.'))
        }
        return nonFloatNumber
      },
      mapflatRateFeeToString (flatRateFee) {
        if ((typeof flatRateFee) === 'string') {
          return flatRateFee
        }
        return flatRateFee.toFixed(2).replace('.', ',')
      },
      mapFlareUsers (users) {
        const usersArray = []

        users.forEach(user => {
          if (user.id) {
            usersArray.push(this.users.find(u => u.id === user.id))
          } else {
            usersArray.push(this.users.find(u => u.id === user))
          }
        })

        return usersArray
      },
      getFrequencyRowText (frequencyValue) {
        if (frequencyValue) {
          const frequency = this.frequencies.find(frequency => frequency.value === frequencyValue)
          return frequency.text
        }
      },
      edit (item) {
        this.editedIndex = this.customer.customerServiceDefinitions.findIndex(definition => definition.service.id === item.service.id)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      closeDefinitionDialog () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      saveDefinition () {
        if (this.editedIndex > -1) {
          Object.assign(this.customer.customerServiceDefinitions[this.editedIndex], this.editedItem)
        } else {
          this.customer.customerServiceDefinitions.push(this.editedItem)
        }
        this.closeDefinitionDialog()
      },
      remove (item) {
        const foundIndex = this.customer.customerServiceDefinitions.findIndex(definition => definition.service.id === item.service.id)
        if (foundIndex > -1) this.customer.customerServiceDefinitions.splice(foundIndex, 1)
      },
      removeUser (item) {
        const fareUser = this.customer.fareUsers.find(fareUser => fareUser.id === item.id)
        const foundIndex = this.customer.fareUsers.indexOf(fareUser)
        if (foundIndex > -1) this.customer.fareUsers.splice(foundIndex, 1)
      }
    }
  }
</script>

<style scoped>
  .v-subheader {
    margin-left: -32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Customers/EditCustomerDialog.vue